import { render } from "./Footer.vue?vue&type=template&id=2eda2d70&scoped=true&bindings={\"fixed\":\"props\",\"isFixed\":\"options\",\"footerComponent\":\"options\",\"inCareering\":\"options\",\"inHomeATM\":\"options\",\"inRole\":\"options\",\"transitionTo\":\"options\"}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2eda2d70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2eda2d70"

export default script